export type Locale = 'en' | 'de';

export const getLocale = (lng?: string): Locale => (lng === 'de' ? 'de' : 'en');

export const formatDate = (date: Date | number | string, locale: Locale, options: Intl.DateTimeFormatOptions = {}): string => {
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    ...options,
  }).format(d);
};

export const formatNumber = (value: number, locale: Locale, options: Intl.NumberFormatOptions = {}): string => {
  return new Intl.NumberFormat(locale, options).format(value);
};

export const formatCurrency = (value: number, locale: Locale, currency: 'USD' | 'EUR' = locale === 'de' ? 'EUR' : 'USD', options: Intl.NumberFormatOptions = {}): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    ...options,
  }).format(value);
};

export const formatCentsCurrency = (cents: number): string => {
  if (Number.isNaN(cents)) return '0,00 €';
  return formatCurrency(cents / 100, 'de', 'EUR');
};
